import {call, takeLatest} from 'redux-saga/effects';
import Swal from "sweetalert2";
import {actions as eventsOverviewActions, types as eventsOverviewTypes} from '../Ducks/eventsOverview';

import * as api from '../API/eventsOverview';
import {callApi} from './utils';
import {EVENTS_OVERVIEW, RESALE_OVERVIEW} from "../Components/Utils/constants";


function* getEventsOverview(action) {
    const {success, failure} = eventsOverviewActions.saga.getEventsOverview;

    yield callApi(
        call(api.getEventsOverview, action.data),
        success,
        failure
    )
}

function* updateAttendanceStatus(action) {
    const {success, failure} = eventsOverviewActions.saga.updateAttendanceStatus;

    function* postApiSuccessCallEffect() {
        yield call(getParticipantDetails, {
            ...action,
            data: {
                event_id: action.data.participantDetails.event_id,
                participant_id: action.data.participantDetails.participant_id
            }
        });

        if (action.data.updateOverviewType === EVENTS_OVERVIEW) {
            yield call(getEventsOverview, {...action, data: action.data.query});
        } else if (action.data.updateOverviewType === RESALE_OVERVIEW) {
            yield call(getResaleOverview, {...action, data: action.data.query});
        }
    }

    yield callApi(
        call(api.updateAttendanceStatus, action.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* updateAttendanceVerification(action) {
    const {success, failure} = eventsOverviewActions.saga.updateAttendanceVerification;

    function* postApiSuccessCallEffect() {
        yield call(getParticipantDetails, {
            ...action,
            data: {
                event_id: action.data.participantDetails.event_id,
                participant_id: action.data.participantDetails.participant_id
            }
        });

        if (action.data.updateOverviewType === EVENTS_OVERVIEW) {
            yield call(getEventsOverview, {...action, data: action.data.query});
        } else if (action.data.updateOverviewType === RESALE_OVERVIEW) {
            yield call(getResaleOverview, {...action, data: action.data.query});
        }
    }

    yield callApi(
        call(api.updateAttendanceVerification, action.data.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* updateSendoutEmail(action) {
    const {success, failure} = eventsOverviewActions.saga.updateSendoutEmail;

    function* postApiSuccessCallEffect() {
        yield call(getEventsOverview, {...action, data: action.data.query});
    }

    yield callApi(
        call(api.updateSendoutEmail, action.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* getPersonPurchases(action) {
    const {success, failure} = eventsOverviewActions.saga.getPersonPurchases;

    function* postApiSuccessCallEffect() {

    }

    yield callApi(
        call(api.getPersonPurchases, action.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* getPersonOpportunities(action) {
    const {success, failure} = eventsOverviewActions.saga.getPersonOpportunities;

    function* postApiSuccessCallEffect() {

    }

    yield callApi(
        call(api.getPersonOpportunities, action.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* getPersonOpenOpportunity(action) {
    const {success, failure} = eventsOverviewActions.saga.getPersonOpenOpportunity;

    function* postApiSuccessCallEffect() {

    }

    yield callApi(
        call(api.getPersonOpenOpportunity, action.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* updatePersonStage(action) {
    const {success, failure} = eventsOverviewActions.saga.updatePersonStage;

    function* postApiSuccessCallEffect() {
        Swal.fire({
            icon: 'success',
            title: 'Done!',
            showConfirmButton: false,
            timer: 1500
        })
    }

    yield callApi(
        call(api.updatePersonStage, action.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* getPersonHistory(action) {
    const {success, failure} = eventsOverviewActions.saga.getPersonHistory;

    yield callApi(
        call(api.getPersonHistory, action.data),
        success,
        failure,
    )
}

function* getNoteTypes(action) {
    const {success, failure} = eventsOverviewActions.saga.getNoteTypes;

    function* postApiSuccessCallEffect() {

    }

    yield callApi(
        call(api.getNoteTypes, action.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* addHistoryLog(action) {
    const {success, failure} = eventsOverviewActions.saga.addHistoryLog;

    function* postApiSuccessCallEffect() {
        yield call(getPersonHistory, {...action, data: {person_id: action.data.id, query: action.data.type}});
    }

    yield callApi(
        call(api.addHistoryLog, action.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* getParticipantDetails(action) {
    const {success, failure} = eventsOverviewActions.saga.getParticipantDetails;

    function* postApiSuccessCallEffect() {

    }

    yield callApi(
        call(api.getParticipantDetails, action.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* getEventDetails(action) {
    const {success, failure} = eventsOverviewActions.saga.getEventDetails;

    function* postApiSuccessCallEffect() {

    }

    yield callApi(
        call(api.getEventDetails, action.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* updateNotes(action) {
    const {success, failure} = eventsOverviewActions.saga.updateNotes;

    function* postApiSuccessCallEffect() {
        yield call(getEventDetails, {...action, data: action.data.event_id});
    }

    yield callApi(
        call(api.updateNotes, action.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* updateEmail(action) {
    const {success, failure} = eventsOverviewActions.saga.updateEmail;

    function* postApiSuccessCallEffect() {
        Swal.fire({
            icon: 'success',
            title: 'Done!',
            showConfirmButton: false,
            timer: 1500
        })
        action.data.setSubmitting(false);
        yield call(getEventDetails, {...action, data: action.data.event_id});
    }

    yield callApi(
        call(api.updateEmail, action.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* deleteAttachedFile(action) {
    const {success, failure} = eventsOverviewActions.saga.deleteAttachedFile;

    function* postApiSuccessCallEffect() {
        yield call(getEventDetails, {...action, data: action.data.event_id});
    }

    yield callApi(
        call(api.deleteAttachedFile, action.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* getNetworkDirectors(action) {
    const {success, failure} = eventsOverviewActions.saga.getNetworkDirectors;

    yield callApi(
        call(api.getNetworkDirectors, action.data),
        success,
        failure
    )
}

function* getEventsOverviewUsers(action) {
    const {success, failure} = eventsOverviewActions.saga.getEventsOverviewUsers;

    yield callApi(
        call(api.getEventsOverviewUsers, action.data),
        success,
        failure
    )
}

function* pauseCase(action) {
    const {success, failure} = eventsOverviewActions.saga.pauseCase;

    function* postApiSuccessCallEffect(_res) {
        yield call(getParticipantDetails, {
            ...action,
            data: {event_id: action.data.event_id, participant_id: action.data.participant_id}
        });
        yield call(getEventsOverview, {...action, data: action.data.query});
        action.data.toggleSpecialCaseTab(false);
    }

    yield callApi(
        call(api.pauseCase, action.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* registerOnGoingCase(action) {
    const {success, failure} = eventsOverviewActions.saga.registerOnGoingCase;

    function* postApiSuccessCallEffect(res) {
        if (res.case_id) {
            yield call(getEventsOverview, {...action, data: action.data.query});
            action.data.toggleSpecialCaseTab(false);
        }
        if (res.case_id && action.data.history_log_data) {
            yield call(addHistoryLog, {
                ...action,
                data: {id: action.data.person_id, type: action.data.type, obj: action.data.history_log_data}
            });
        }
    }

    yield callApi(
        call(api.registerOnGoingCase, action.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* getSpecialCaseDetails(action) {
    const {success, failure} = eventsOverviewActions.saga.getSpecialCaseDetails;

    yield callApi(
        call(api.getSpecialCaseDetails, action.data),
        success,
        failure
    )
}

function* getCasesOverview(action) {
    const {success, failure} = eventsOverviewActions.saga.getCasesOverview;

    yield callApi(
        call(api.getCasesOverview, action.data),
        success,
        failure
    )
}

function* getResaleOverview(action) {
    const {success, failure} = eventsOverviewActions.saga.getResaleOverview;

    yield callApi(
        call(api.getResaleOverview, action.data),
        success,
        failure
    )
}

function* getPendingCases(action) {
    const {success, failure} = eventsOverviewActions.saga.getPendingCases;

    yield callApi(
        call(api.getPendingCases, action.data),
        success,
        failure
    )
}

function* getCaseUsersList(action) {
    const {success, failure} = eventsOverviewActions.saga.getCaseUsersList;

    yield callApi(
        call(api.getCaseUsersList, action.data),
        success,
        failure
    )
}

function* getEventMembers(action) {
    const {success, failure} = eventsOverviewActions.saga.getEventMembers;

    yield callApi(
        call(api.getEventMembers, action.data),
        success,
        failure
    )
}

function* resolveCase(action) {
    const {success, failure} = eventsOverviewActions.saga.resolveCase;

    function* postApiSuccessCallEffect() {
        Swal.fire({
            icon: 'success',
            title: 'Case resolved successfully!',
            showConfirmButton: false,
            timer: 1500
        })
        action.data.handleCaseClose();
        yield call(getPendingCases, {...action, data: {}});
    }

    yield callApi(
        call(api.resolveCase, action.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* caseDecline(action) {
    const {success, failure} = eventsOverviewActions.saga.caseDecline;

    function* postApiSuccessCallEffect() {
        Swal.fire({
            icon: 'success',
            title: 'Case Decline successfully!',
            showConfirmButton: false,
            timer: 1500
        })
        action.data.handleCaseClose();
        yield call(getCasesOverview, {...action, data: action.data.query});
        yield call(getPendingCases, {...action, data: {}});
    }

    yield callApi(
        call(api.caseDecline, action.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )
}

function* getCasesEventsOverview(action) {
    const {success, failure} = eventsOverviewActions.saga.getCasesEventsOverview;
    yield callApi(
        call(api.getCasesEventsOverview, action.data),
        success,
        failure
    )
}

function* updateAssignee(action) {
    function* postApiSuccessCallEffect() {
        Swal.fire({
            icon: 'success',
            title: 'Case Reassigned successfully!',
            showConfirmButton: false,
            timer: 1500
        })
        yield call(getSpecialCaseDetails, {...action, data: action.data.purchaseId});
        yield call(getCasesOverview, action.data);
    }

    const {success, failure} = eventsOverviewActions.saga.updateAssignee;
    yield callApi(
        call(api.updateAssignee, action.data),
        success,
        failure,
        {postApiSuccessCallEffect}
    )

}

function* getPendingCaseDetails(action) {
    const {success, failure} = eventsOverviewActions.saga.getPendingCaseDetails;

    yield callApi(
        call(api.pendingCaseDetails, action.data),
        success,
        failure
    )
}

export default function* rootCustomerSaga() {
    yield takeLatest(eventsOverviewTypes.getEventsOverview, getEventsOverview);
    yield takeLatest(eventsOverviewTypes.updateAttendanceStatus, updateAttendanceStatus);
    yield takeLatest(eventsOverviewTypes.updateAttendanceVerification, updateAttendanceVerification);
    yield takeLatest(eventsOverviewTypes.updateSendoutEmail, updateSendoutEmail);
    yield takeLatest(eventsOverviewTypes.getPersonPurchases, getPersonPurchases);
    yield takeLatest(eventsOverviewTypes.getPersonOpportunities, getPersonOpportunities);
    yield takeLatest(eventsOverviewTypes.getPersonOpenOpportunity, getPersonOpenOpportunity);
    yield takeLatest(eventsOverviewTypes.getPersonHistory, getPersonHistory);
    yield takeLatest(eventsOverviewTypes.getParticipantDetails, getParticipantDetails);
    yield takeLatest(eventsOverviewTypes.getEventDetails, getEventDetails);
    yield takeLatest(eventsOverviewTypes.getNoteTypes, getNoteTypes);
    yield takeLatest(eventsOverviewTypes.addHistoryLog, addHistoryLog);
    yield takeLatest(eventsOverviewTypes.updateNotes, updateNotes);
    yield takeLatest(eventsOverviewTypes.updateEmail, updateEmail);
    yield takeLatest(eventsOverviewTypes.getNetworkDirectors, getNetworkDirectors);
    yield takeLatest(eventsOverviewTypes.getEventsOverviewUsers, getEventsOverviewUsers);
    yield takeLatest(eventsOverviewTypes.deleteAttachedFile, deleteAttachedFile);
    yield takeLatest(eventsOverviewTypes.updatePersonStage, updatePersonStage);
    yield takeLatest(eventsOverviewTypes.pauseCase, pauseCase);
    yield takeLatest(eventsOverviewTypes.registerOnGoingCase, registerOnGoingCase);
    yield takeLatest(eventsOverviewTypes.getSpecialCaseDetails, getSpecialCaseDetails);
    yield takeLatest(eventsOverviewTypes.getCasesOverview, getCasesOverview);
    yield takeLatest(eventsOverviewTypes.getResaleOverview, getResaleOverview);
    yield takeLatest(eventsOverviewTypes.resolveCase, resolveCase);
    yield takeLatest(eventsOverviewTypes.getPendingCases, getPendingCases);
    yield takeLatest(eventsOverviewTypes.getCaseUsersList, getCaseUsersList);
    yield takeLatest(eventsOverviewTypes.getEventMembers, getEventMembers);
    yield takeLatest(eventsOverviewTypes.caseDecline, caseDecline);
    yield takeLatest(eventsOverviewTypes.getCasesEventsOverview, getCasesEventsOverview);
    yield takeLatest(eventsOverviewTypes.updateAssignee, updateAssignee);
    yield takeLatest(eventsOverviewTypes.getPendingCaseDetails, getPendingCaseDetails);
}